import registry from "./workspace-admin-permissions.json";
import {normalizePermissionList} from "./workspace-permissions";

export const WORKSPACE_ADMIN_PERMISSION_GROUPS = registry.groups;
export const WORKSPACE_ADMIN_PERMISSIONS = registry.groups
    .flatMap((group) => group.permissions);
export const WORKSPACE_ADMIN_PERMISSION_KEYS = WORKSPACE_ADMIN_PERMISSIONS
    .map((permission) => permission.key);

const permissionMap = new Map(
    WORKSPACE_ADMIN_PERMISSIONS.map((permission) => [permission.key, permission]),
);
const permissionKeySet = new Set(WORKSPACE_ADMIN_PERMISSION_KEYS);

export function normalizeWorkspaceAdminPermissions(value) {
    const aliases = {"access-to-crm": ["customers.read"]};
    const normalized = normalizePermissionList(value).flatMap((permission) => aliases[permission] || [permission]);
    const selected = new Set(
        normalized.filter((permission) => permissionKeySet.has(permission)),
    );

    let dependencyAdded = true;
    while (dependencyAdded) {
        dependencyAdded = false;
        for (const permission of [...selected]) {
            for (const dependency of permissionMap.get(permission)?.dependencies || []) {
                if (!selected.has(dependency)) {
                    selected.add(dependency);
                    dependencyAdded = true;
                }
            }
        }
    }

    return WORKSPACE_ADMIN_PERMISSION_KEYS.filter((permission) => selected.has(permission));
}

export function toggleWorkspaceAdminPermission(value, permission, enabled) {
    const selected = new Set(normalizeWorkspaceAdminPermissions(value));
    if (enabled) {
        selected.add(permission);
    } else {
        selected.delete(permission);
        for (const candidate of WORKSPACE_ADMIN_PERMISSIONS) {
            if (candidate.dependencies?.includes(permission)) selected.delete(candidate.key);
        }
    }
    return normalizeWorkspaceAdminPermissions([...selected]);
}

export function setWorkspaceAdminPermissionGroup(value, groupId, enabled) {
    const group = WORKSPACE_ADMIN_PERMISSION_GROUPS.find((item) => item.id === groupId);
    if (!group) return normalizeWorkspaceAdminPermissions(value);

    let next = normalizeWorkspaceAdminPermissions(value);
    for (const permission of group.permissions) {
        next = toggleWorkspaceAdminPermission(next, permission.key, enabled);
    }
    return next;
}
